import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToastrService } from 'ngx-toastr';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DiscussionProjectsService } from '../../_services/discussionProjects.service';
import { ProvinceService } from '../../_services/province.service';
import { Province } from 'app/_models/province';
import { AccountsService } from 'app/_services/accounts.service';
@Component({
  selector: 'app-projects-list',
  templateUrl: './provinces.component.html',
  styleUrls: ['./provinces.component.scss']
})
export class ProvincesComponent implements OnInit {
  public provinces = Array();
  public password = '';
  public currentProject;
  public isEdit;
  dtOptions: DataTables.Settings = {};
  bsConfig: Partial<BsDatepickerConfig>;
  public projectSelecteds = Array();
  public projectDropdowlists = Array();
  public discussionProjects = Array();
  public dataTableShow: Object = false;
  public province: Province;
  public accounts = Array();
  public accountSelecteds = Array();
  public imformationAccounts= Array();
  projectDropDownSettings = {
    text: "Chọn tài khoản ...",
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    classes: "myclass custom-class",
    enableSearchFilter: true,
    singleSelection: false,
    badgeShowLimit: 4
  };
  //filter
  filter = {};
  //loai nhom
  typeGroupDropDownSettings = {
    singleSelection: true,
    text: 'Chọn kiểu nhóm',
    enableSearchFilter: false,
  };
  typeGroups = [
    { 'id': 1, 'itemName': 'Nhóm theo tỉnh / thành phố', value: 'province' },
    { 'id': 2, 'itemName': 'Nhóm theo tài khoản', value: 'account' }
  ];
  typeGroupSelected = [
    { 'id': 1, 'itemName': 'Nhóm theo tỉnh / thành phố', value: 'province' }
  ];
  //tim kiem theo ten
  provinceSearch = "";
  modalRef: BsModalRef;
  modalRef1: BsModalRef;
  public config2 = {
    keyboard: false,
    backdrop: 'static',
    class: 'modal-lg'
  };
  public config1 = {
    keyboard: false,
      backdrop: 'static',
    class: 'modal-sm'
  };

  public view;

  public nodeChecked(args): void {

  }
  constructor(
    private modalService: BsModalService,
    private toastrService: ToastrService,
    private provinceService: ProvinceService,
    private discussionProjectsService: DiscussionProjectsService,
    private accountsService: AccountsService) {
  }

  ngOnInit(): void {
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-blue',
    });
    this.dataTableShow = true;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: false,
      paging: true,
      searching: false,
      ordering: false,
      language: {
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        infoEmpty: 'Không tìm thấy dữ liệu phù hợp',
        infoFiltered: '(trong _MAX_)',
        lengthMenu: 'Hiển thị _MENU_',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu',
      }
    };
    this.getAccount();
    setTimeout(() => {
      this.getProvinces();
    }, 500);
  };

  //get Province
  getProvinces() {
    if (this.typeGroupSelected.length == 0) {
      this.toastrService.error("Phải chọn kiểu nhóm!", "Thông báo!");
      return;
    }
    let accountSearch = Array();
    if (this.accountSelecteds.length > 0) {
      for (var i = 0; i < this.accountSelecteds.length; i++) {
        accountSearch.push(this.accountSelecteds[i].value);
      }
    }
    let accountFilters = Array();
    if (this.accounts.length > 0) {
      for (var i = 0; i < this.accounts.length; i++) {
        accountFilters.push(this.accounts[i].value);
      }
    }
    this.filter = {
      provinceSearch: this.provinceSearch,
      accountSearch: accountSearch,
      typeGroup: this.typeGroupSelected[0].value,
      accounts: accountFilters
    };
    this.dataTableShow = false;
    //Nhom theo tỉnh thành
    this.provinceService.index(this.filter).subscribe(res => {
      if (res.success) {
        if (this.typeGroupSelected[0].value == "province") {
          this.provinces = res.data.provinces;
        } else {
          this.imformationAccounts=res.data;
        }
      } else {
        this.toastrService.error("Có lỗi xảy ra!", "Thông báo");
      }
      this.dataTableShow = true;
    });
  }
  //get account
  getAccount() {
    this.accountsService.getListKtv().subscribe(response => {
      if (response.success) {
        response.data.accounts.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.username,
            value: element.username
          };
          this.accounts.push(obj);
        });
      }
    });
  }
  addProvince(template) {

    this.isEdit = false;
    this.province = new Province();
    this.province.name = "";
    this.province.accounts = [];
    const add = document.getElementById('addProvince');
    add.blur();
    this.modalRef = this.modalService.show(template, this.config2);
  }
  validateProvince() {
    if (this.province.name == "" || this.province.name.length > 200) {
      this.toastrService.warning("Tên Tỉnh thành không được để trống và không được quá 200 ký tự!", "Thông báo");
      return false;
    }
    return true;
  }
  addProvinceProccess() {
    if (this.validateProvince()) {
      this.provinceService.create(this.province).subscribe(response => {
        if (response.success) {
          this.toastrService.success(response.message, 'Thành công');
          this.modalRef.hide();
          this.getProvinces();
        } else {
          this.toastrService.error(response.message, 'Thông báo');
        }
      },
        err => {
          this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
        });
    }
  }
  editProvince(template, item) {
    this.isEdit = true;
    this.province = new Province();
    this.province._id = item._id;
    this.province.name = item.name;
    this.province.accounts = Object.assign([], item.accounts);
    const add = document.getElementById('editProvince');
    add.blur();
    this.modalRef = this.modalService.show(template, this.config2);

  }
  updateProjectProccess() {
    if (this.validateProvince()) {
      this.provinceService.update(this.province).subscribe(response => {
        if (response.success) {
          this.toastrService.success(response.message, 'Thành công');
          this.modalRef.hide();
          this.getProvinces();
        } else {
          this.toastrService.error(response.message, 'Thông báo');
        }
      },
        err => {
          this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
        });
    }
  }
  closeModal() {
    this.modalRef.hide();
  }
  deleteProvince(template, item) {
    this.province = item;
    const add = document.getElementById('deleteProvince');
    add.blur();
    this.modalRef1 = this.modalService.show(template, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-md'
    });
  }
  delete() {
    this.provinceService.delete({ id: this.province._id })
      .subscribe(response => {
        if (response.success) {
          this.modalRef1.hide();
          this.getProvinces();
          this.toastrService.success(response.message, 'Thành công');
        } else {
          this.toastrService.warning(response.message, 'Thông báo');
        }
      },
        err => {
          this.toastrService.error('Có lỗi xảy ra!', 'Lỗi');
        });
  }
  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }



}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/provinces/provinces.component.ts